function isGiftCard(item) {
  if (item.product_id === 10521525289297) {
    return true;
  }

  if (item.handle === "bon-cadeau") {
    return true;
  }

  if (
    item.vendor &&
    item.vendor === "Zuqini" &&
    item.title &&
    item.title.includes("Bon cadeau")
  ) {
    return true;
  }

  if (item.product_type && item.product_type === "Tarjetas de regalo") {
    return true;
  }

  return false;
}

function calculateTotalWithoutGiftCards(cartData) {
  let totalWithoutGiftCards = 0;

  cartData.items.forEach((item) => {
    if (!isGiftCard(item)) {
      totalWithoutGiftCards += item.price * item.quantity;
    }
  });

  return totalWithoutGiftCards;
}

function hasOnlyGiftCards(cartData) {
  return cartData.items.every((item) => isGiftCard(item));
}

function calculateDeliveryCost(cartData) {
  const TIER_1 = 5000;  // 50.00 CHF
  const TIER_2 = 10000;  // 100.00 CHF
  const DELIVERY_HIGH = 650;   // 6.50 CHF
  const DELIVERY_MID = 650;    // 6.50 CHF

  if (hasOnlyGiftCards(cartData)) {
    return {
      cost: 0,
      isFree: true,
      text: "Gratuit"
    };
  }

  const totalPrice = calculateTotalWithoutGiftCards(cartData);

  if (totalPrice < TIER_1) {
    return {
      cost: DELIVERY_HIGH,
      isFree: false,
      text: `CHF ${(DELIVERY_HIGH / 100).toFixed(2)}`
    };
  } else if (totalPrice < TIER_2) {
    return {
      cost: DELIVERY_MID,
      isFree: false,
      text: `CHF ${(DELIVERY_MID / 100).toFixed(2)}`
    };
  } else {
    return {
      cost: 0,
      isFree: true,
      text: "Gratuit"
    };
  }
}

function getDeliveryNudgeMessage(cartData) {
  const TIER_1 = 4300;  // 43.00 CHF
  const TIER_2 = 8600;  // 86.00 CHF

  if (hasOnlyGiftCards(cartData)) {
    return "";
  }

  const totalPrice = calculateTotalWithoutGiftCards(cartData);

  if (totalPrice < TIER_1) {
    return `
      <p style="
        font-size: 13px;
        color: #333;
        text-align: center; 
        line-height: 1.5;
      ">
        Pour 2 plats, livraison pour seulement 6,5 CHF dès 3 plats offerte!
      </p>
    `;
  } else if (totalPrice >= TIER_1 && totalPrice < TIER_2) {
    return `
      <p style="
        font-size: 13px;
        color: #333;
        text-align: center;
        line-height: 1.5;
      ">
        Ajoute un plat pour avoir la livraison offerte.
      </p>
    `;
  } else {
    return `
      <p style="
        font-size: 13px;
        color: #333;
        text-align: center;
        font-weight: bold;
        line-height: 1.5;
      ">
        Livraison offerte
      </p>
    `;
  }
}

function getDeliveryEstimateMessage(cartData) {
  if (hasOnlyGiftCards(cartData)) {
    return "";
  }

  const now = new Date();
  const day = now.getDay();
  const hour = now.getHours();
  const minute = now.getMinutes();

  let deliveryMonday;

  function getMondayOfNextWeek(date) {
    const monday = new Date(date);
    const daysUntilNextMonday = (8 - date.getDay()) % 7 || 7;
    monday.setDate(date.getDate() + daysUntilNextMonday);
    return monday;
  }

  function getWedThuFromMonday(monday) {
    const wed = new Date(monday);
    wed.setDate(monday.getDate() + 2);
    const thu = new Date(monday);
    thu.setDate(monday.getDate() + 3);
    return [wed, thu];
  }

  if (day >= 1 && day <= 5 && (hour < 15 || (hour === 15 && minute === 0))) {
    deliveryMonday = getMondayOfNextWeek(now);
} else if (
    (day === 5 && (hour > 15 || (hour === 15 && minute > 0))) ||
    day === 6 ||
    day === 0
  ) {
    const mondayNextWeek = getMondayOfNextWeek(now);
    deliveryMonday = new Date(mondayNextWeek);
    deliveryMonday.setDate(mondayNextWeek.getDate() + 7);
  } else {
    deliveryMonday = getMondayOfNextWeek(now);
  }

  const [deliveryDate1, deliveryDate2] = getWedThuFromMonday(deliveryMonday);

  const options = { weekday: "long", day: "numeric", month: "long" };
  return `Livraison estimée le ${deliveryDate2.toLocaleDateString("fr-FR", options)}.`;
}

async function updateCartModal() {
  const cartResponse = await fetch("/cart.js");
  const cartData = await cartResponse.json();

  const modalProduct = document.getElementById("cart-notification-product");
  const cartLinks = document.querySelector(".cart-notification__links");

  if (cartData.items.length === 0) {
    modalProduct.innerHTML = `
      <div class="cart-empty-krf" style="text-align: center; padding: 40px; color: #333; font-family: sans-serif;">
        <img src="${window.iconCartEmptyUrl}" alt="Carrito vacío" style="width: 80px; height: 80px; margin-bottom: 20px; opacity: 0.6;">
        <p style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">Votre panier est vide</p>
        <a href="/" style="display: inline-block; margin-bottom: 20px; color: #000; text-decoration: underline;">Continuer les achats</a>
      </div>
    `;

    const existingSummary = document.getElementById("cart-summary");
    if (existingSummary) existingSummary.remove();

    if (cartLinks) cartLinks.style.display = "none";
    return;
  }

  if (cartLinks) cartLinks.style.display = "";

  const deliveryInfo = calculateDeliveryCost(cartData);

  const totalConLivraison = deliveryInfo.isFree
    ? cartData.total_price
    : cartData.total_price + deliveryInfo.cost;

  const nudgeMessageForSummary = getDeliveryNudgeMessage(cartData);
  const deliveryEstimate = getDeliveryEstimateMessage(cartData);

  modalProduct.innerHTML = `
    <div class="cart-notification-content">
      <div class="zq-cart-table">
        <div class="zq-cart-table__row" style="font-weight: bold;">
          <div class="zq-cart-table__name">Produit</div>
          <div class="zq-cart-table__total">Total</div>
        </div>
        ${cartData.items
          .map((item) => {
            const totalItem = ((item.price * item.quantity) / 100).toFixed(2);
            const unitPrice = (item.price / 100).toFixed(2);

            let pricePerPersonText = "";
            if (item.properties && item.properties._precio_por_persona) {
              pricePerPersonText = item.properties._precio_por_persona;
            }

            return `
            <div class="zq-cart-table__row" data-key="${item.key}">
              <a href="${item.url}">
                <img class="zq-cart-table__image" src="${item.image}" alt="${item.title}" style="cursor: pointer;">
              </a>
              <div class="zq-cart-table__name">
                <strong style="
                  font-size: 12px;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;">
                  <a href="${item.url}" style="color: inherit; text-decoration: none;">
                    ${item.title}
                  </a>
                </strong>
                <span style="font-size: 12px;">CHF ${unitPrice}</span>
                <span style="font-size: 12px; display: block; height: 5px;"></span>
                <div style="display: flex; align-items: center; gap: 10px;">
                  <quantity-input class="quantity" data-key="${item.key}">
                    <button class="quantity__button" name="minus" type="button">-</button>
                    <input class="quantity__input" type="number" name="quantity" value="${item.quantity}" min="1">
                    <button class="quantity__button" name="plus" type="button">+</button>
                  </quantity-input>
                  <button class="zq-remove-item-btn" data-key="${item.key}" style="border:none; background:none; padding:0;">
                    <img src="${window.iconRemoveUrl}" alt="Eliminar" style="width: 16px; height: 16px; filter: invert(0);" />
                  </button>
                </div>
              </div>
              <div class="zq-cart-table__total">
                CHF ${totalItem}<br>
                ${pricePerPersonText ? `<span style="font-size: 10px;">${pricePerPersonText}</span>` : ""}
              </div>
            </div>
          `;
          })
          .join("")}
      </div>
    </div>
  `;

  const summaryHTML = `
    <div id="cart-summary" class="zq-cart-summary">
      ${nudgeMessageForSummary}
      
      ${
        deliveryEstimate
          ? `
      <div class="zq-cart-summary__row">
        <p style="font-size: 13px; color: #333; font-weight: bold;">
          ${deliveryEstimate}
        </p>
      </div>
      `
          : ""
      }
      
      <div class="zq-cart-summary__row">
        <h2 class="zq-cart-summary__label">Subtotal</h2>
        <p class="zq-cart-summary__value">CHF ${(cartData.items_subtotal_price / 100).toFixed(2)}</p>
      </div>
      <div class="zq-cart-summary__row">
        <h2 class="zq-cart-summary__label">Livraison</h2>
        <p class="zq-cart-summary__value">${deliveryInfo.text}</p>
      </div>
      <div class="zq-cart-summary__row zq-cart-summary__total" style="font-weight: bold;">
        <h2 class="zq-cart-summary__label">Total estimé</h2>
        <p class="zq-cart-summary__value">CHF ${(totalConLivraison / 100).toFixed(2)}</p>
      </div>
      <span style="font-size: 12px; display: block; height: 5px;"></span>
      <small class="tax-note caption-large rte"> 
      Taxes incluses. Réductions calculées à l'étape du paiement.</small>
    </div>
  `;

  const existingSummary = document.getElementById("cart-summary");
  if (existingSummary) {
    existingSummary.outerHTML = summaryHTML;
  } else if (cartLinks) {
    cartLinks.insertAdjacentHTML("afterbegin", summaryHTML);
  }

  modalProduct.querySelectorAll("quantity-input").forEach((qty) => {
    const key = qty.dataset.key;
    const input = qty.querySelector(".quantity__input");
    const minus = qty.querySelector('button[name="minus"]');
    const plus = qty.querySelector('button[name="plus"]');
    const min = parseInt(input.min) || 1;

    minus.addEventListener(
      "click",
      async (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();
        let quantity = Math.max(parseInt(input.value) - 1, min);
        input.value = quantity;
        await changeCartItem(key, quantity);
        await updateQuantityLabels();
      },
      { capture: true }
    );

    plus.addEventListener(
      "click",
      async (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();
        let quantity = parseInt(input.value) + 1;
        input.value = quantity;
        await changeCartItem(key, quantity);
        await updateQuantityLabels();
      },
      { capture: true }
    );

    input.addEventListener(
      "change",
      async (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();
        let quantity = Math.max(parseInt(input.value), min);
        input.value = quantity;
        await changeCartItem(key, quantity);
        await updateQuantityLabels();
      },
      { capture: true }
    );
  });

  modalProduct.querySelectorAll(".zq-remove-item-btn").forEach((btn) => {
    const key = btn.dataset.key;
    btn.addEventListener("click", async () => {
      await changeCartItem(key, 0);
      await updateQuantityLabels();
    });
  });

  await updateQuantityLabels();
  updateCartIconBubble(cartData);
}

async function changeCartItem(key, quantity) {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: key, quantity })
  });

  const updatedCart = await response.json();
  await updateCartModal(updatedCart);
  updateCartIconBubble(updatedCart);
}

document.querySelectorAll(".add-to-cart-ajax").forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    
    const selectedVariantInput = document.querySelector('input[name="id"]:checked') || 
                                 document.querySelector('select[name="id"]') ||
                                 document.querySelector('input[name="id"]');
    
    const variantId = selectedVariantInput ? selectedVariantInput.value : form.dataset.variantId;
    const quantity = 1;
    const precioPersona = form.dataset.precioPersona || "";

    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity,
          properties: {
            _precio_por_persona: precioPersona
          }
        })
      });

      await updateCartModal();
      await updateQuantityLabels();

      const cartModal = document.getElementById("cart-notification");
      cartModal.classList.add("active");
      document.querySelector(".cart-overlay").classList.add("active");
      cartModal.focus();
      toggleCart(true);
    } catch (error) {
      console.error("Error agregando producto al carrito", error);
    }
  });
});

function updateCartIconBubble(cartData) {
  const cartIcon = document.getElementById("cart-icon-bubble");
  if (!cartIcon) return;

  let bubble = cartIcon.querySelector(".cart-count-bubble");
  if (bubble) bubble.remove();

  const iconContainer = cartIcon.querySelector("svg, img");

  if (cartData.item_count === 0) {
    if (iconContainer) iconContainer.src = window.iconCartEmptyUrl;
    return;
  } else {
    if (iconContainer) iconContainer.src = window.iconCartFullUrl;
  }

  const newBubble = document.createElement("div");
  newBubble.className = "cart-count-bubble";
  newBubble.innerHTML =
    cartData.item_count < 100
      ? `<span aria-hidden="true">${cartData.item_count}</span>`
      : `<span aria-hidden="true">99+</span>`;

  const visuallyHidden = document.createElement("span");
  visuallyHidden.className = "visually-hidden";
  visuallyHidden.textContent = `Carrito, ${cartData.item_count} items`;

  newBubble.appendChild(visuallyHidden);
  cartIcon.appendChild(newBubble);
}

document
  .getElementById("cart-icon-bubble")
  .addEventListener("click", async (event) => {
    event.preventDefault();
    await updateCartModal();
    const cartModal = document.getElementById("cart-notification");
    const overlay = document.querySelector(".cart-overlay");
    cartModal.classList.add("active");
    if (overlay) overlay.classList.add("active");
    cartModal.focus();
    toggleCart(true);
  });

document.addEventListener("DOMContentLoaded", async () => {
  try {
    const response = await fetch("/cart.js");
    const cartData = await response.json();
    updateCartIconBubble(cartData);
    await updateQuantityLabels();
  } catch (error) {
    console.error("Error obteniendo carrito al cargar la página", error);
  }
});

async function updateQuantityLabels() {
  const response = await fetch("/cart.js");
  const cartData = await response.json();

  document.querySelectorAll(".zq-quantity-label").forEach((label) => {
    const variantId = parseInt(label.dataset.variantId, 10);
    const item = cartData.items.find((i) => i.id === variantId);
    label.textContent = item
      ? `Quantité (${item.quantity} dans le panier)`
      : "Quantité";
  });

  updateCartIconBubble(cartData);
}

function toggleCart(open) {
  const cart = document.querySelector(".cart-notification");
  const overlay = document.querySelector(".cart-overlay");
  const whatsapp = document.querySelector("#chat-bubble");
  const klaviyoTeaser = document.querySelector(".kl-teaser-Yn4wnu");

  if (open) {
    cart.classList.add("active");
    if (overlay) overlay.classList.add("active");
    if (whatsapp) whatsapp.style.display = "none";
    if (klaviyoTeaser) {
      klaviyoTeaser.style.display = "none";
      klaviyoTeaser.style.visibility = "hidden";
    }
  } else {
    cart.classList.remove("active");
    if (overlay) overlay.classList.remove("active");
    if (whatsapp) whatsapp.style.display = "";
    if (klaviyoTeaser) {
      klaviyoTeaser.style.display = "";
      klaviyoTeaser.style.visibility = "visible";
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".cart-overlay")) {
    const overlay = document.createElement("div");
    overlay.className = "cart-overlay";
    document.body.appendChild(overlay);

    overlay.addEventListener("click", () => {
      toggleCart(false);
    });
  }

  setInterval(() => {
    const cartIsOpen = document.querySelector(".cart-notification.active");
    const klaviyoTeaser = document.querySelector(".kl-teaser-Yn4wnu");

    if (cartIsOpen && klaviyoTeaser && klaviyoTeaser.style.display !== "none") {
      klaviyoTeaser.style.display = "none";
      klaviyoTeaser.style.visibility = "hidden";
    } else if (
      !cartIsOpen &&
      klaviyoTeaser &&
      klaviyoTeaser.style.display === "none"
    ) {
      klaviyoTeaser.style.display = "";
      klaviyoTeaser.style.visibility = "visible";
    }
  }, 100);
});